
import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { EndPortLink } from "../1-devices/link-device-model";

/** Representa o modelo para criação de Links da aba geral */
export class GeneralLinkModel extends NmsWizardStepModel {
    id?: number;
    name: string;
    linkType: number;
    distance?: number;
    attenuation?: number;
    description: string;
    weight: number;
    generatedName: boolean;
    aEndLink?: EndPortLink;
    zEndLink?: EndPortLink;
}
